import { DeliveryPeriodsLoaded, DeliveryPeriodAdded, DeliveryPeriodUpdated, DeliveryPeriodDeleted, DeliveryPeriodsUploaded, DeliveryPeriodsImported, DeliveryPeriodDeletedWithId } from "./deliveryPeriod.actions";
import DeliveryPeriod, { DeliveryPeriodVisibility } from "domain/deliveryPeriod";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import DeliveryPeriodsBulkUploadResponse from "./uploadDeliveryPeriodsResponse";

export default class DeliveryPeriodReducer extends ReducerBase<DeliveryPeriod[]> {
    constructor() {
        super();
        this.addHandler(DeliveryPeriodsLoaded.EventName, this.handleDeliveryPeriodsLoaded);
        this.addHandler(DeliveryPeriodAdded.EventName, this.handleDeliveryPeriodAdded);
        this.addHandler(DeliveryPeriodUpdated.EventName, this.handleDeliveryPeriodUpdated);
        this.addHandler(DeliveryPeriodDeleted.EventName, this.handleDeliveryPeriodDeleted);
        this.addHandler(DeliveryPeriodDeletedWithId.EventName, this.handleDeliveryPeriodDeletedWithId);
    }

    handleDeliveryPeriodsLoaded(state: DeliveryPeriod[] = initialState.deliveryPeriods, event: DeliveryPeriodsLoaded): DeliveryPeriod[] {
        return event.deliveryPeriods;
    }

    handleDeliveryPeriodAdded(
        state: DeliveryPeriod[] = initialState.deliveryPeriods,
        event: DeliveryPeriodAdded
    ): DeliveryPeriod[] {
        if (event.newDeliveryPeriod.visibility === DeliveryPeriodVisibility.BidEditorOnly) return state;

        return addOrUpdateDeliveryPeriod(state, event.newDeliveryPeriod);
    }

    handleDeliveryPeriodUpdated(
        state: DeliveryPeriod[] = initialState.deliveryPeriods,
        event: DeliveryPeriodUpdated
    ): DeliveryPeriod[] {
        
        if (event.deliveryPeriod.visibility === DeliveryPeriodVisibility.BidEditorOnly) {
            return removeDeliveryPeriod(state, event.deliveryPeriod.id);
        }

        return addOrUpdateDeliveryPeriod(state, event.deliveryPeriod);
    }

    handleDeliveryPeriodDeleted(
        state: DeliveryPeriod[] = initialState.deliveryPeriods,
        event: DeliveryPeriodDeleted
    ): DeliveryPeriod[] {
        return removeDeliveryPeriod(state, event.deliveryPeriod.id);
    }

    handleDeliveryPeriodDeletedWithId(
        state: DeliveryPeriod[] = initialState.deliveryPeriods,
        event: DeliveryPeriodDeletedWithId
    ): DeliveryPeriod[] {
        return removeDeliveryPeriod(state, event.deliveryPeriodId);
    }

    handleDefault(state: DeliveryPeriod[] = initialState.deliveryPeriods) {
        return state;
    }
}

function addOrUpdateDeliveryPeriod(state: DeliveryPeriod[], deliveryPeriod: DeliveryPeriod): DeliveryPeriod[] {
    if (state == null) return null;

    if(!state.some(x => x.id === deliveryPeriod.id)) {
        return [...state, {...deliveryPeriod}];
    }
    return state.map(p => (p.id === deliveryPeriod.id ? deliveryPeriod : p));
}

function removeDeliveryPeriod(state: DeliveryPeriod[], id: string): DeliveryPeriod[] {
    if (state == null) return null;

    return state.filter(p => (p.id !== id));
}

export class DeliveryPeriodBulkUploadResponseReducer extends ReducerBase<DeliveryPeriodsBulkUploadResponse> {
    constructor() {
      super();
      this.addHandler(DeliveryPeriodsUploaded.EventName, this.handleDeliveryPeriodsUploaded);
      this.addHandler(DeliveryPeriodsImported.EventName, this.handleDeliveryPeriodsImported);
    }
  
    handleDeliveryPeriodsUploaded(
      state: DeliveryPeriodsBulkUploadResponse = initialState.deliveryPeriodsBulkUploadResponse,
      event: DeliveryPeriodsUploaded
    ): DeliveryPeriodsBulkUploadResponse {
      return event.deliveryPeriodsBulkUploadResponse;
    }
  
    handleDeliveryPeriodsImported(
      state: DeliveryPeriodsBulkUploadResponse = initialState.deliveryPeriodsBulkUploadResponse,
      event: DeliveryPeriodsImported
    ): DeliveryPeriodsBulkUploadResponse {
      return event.deliveryPeriodsBulkUploadResponse;
    }
  
    handleDefault(state: DeliveryPeriodsBulkUploadResponse = initialState.deliveryPeriodsBulkUploadResponse) {
      return state;
    }
  }